export enum FeatureToggle {
  storefrontShortcutsBar = 'rt_storefront_shortcuts_bar',
}
